import { connect } from "react-redux";
import {
  changePageSizeUser,
  cleanMessageUser,
  getDropDownUser,
  getListaUser,
  loadEmptyUser,
} from "../../store/user/actions";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { Helmet } from "react-helmet-async";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import { useEffect, useState } from "react";
import "../../assets/scss/_commomAdminPages.scss";
import FilterAdmin from "../../components/FilterAdmin/FilterAdmin";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import renderBoolean from "../../components/RenderCellsDatatable/renderBoolean";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const UserList = ({
  getListaUserRequest,
  loadingUser,
  listaUser,
  loadEmptyUser,
  pageSizeUser,
  changePageSizeUser,
  cleanMessageUser,
  messageUser
}) => {
  const isFistRender = useIsFirstRender();
  const navigate = useNavigate();
  const alertModal = withReactContent(Swal);
  const [objFilter, setObjFilter] = useState({
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    createUser: null,
    updateUser: null,
    status: true,
  });

  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeUser,
    page: 0,
  });

  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeUser(pageSize);

    getListaUserRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      email: objFilter.search,
    });

  };

  const handleSortChange = (model) => {
    console.log(model);
    setTimeout(() => {
      //
    }, 300);
  };

  const handleRowClick = (params, event) => {
    navigate(`/user?id=${params.id}`);
  };

  const actions = useContextActions({
      context: "user",
      screen: "list",
    });

  useEffect(() => {
    if (isFistRender) loadEmptyUser();

    setPaginationModel(prev => ({
      ...prev,
      page: 0,
    }));

    getListaUserRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      email: objFilter.search,
    });

    // eslint-disable-next-line
  }, [objFilter]);

  useEffect(() => {
    if (messageUser) {
      alertModal
        .fire({
          title: `${
            messageUser !== null
              ? messageUser
              : "Something wrong, try again later."
          }`,
          icon: "error",
          showConfirmButton: false,
          timer: undefined,
          showCloseButton: true,
          timerProgressBar: false,
        })
        .then(() => {
          cleanMessageUser();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageUser]);

  useEffect(() => {
    return () => {
      cleanMessageUser();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-content">
      <Helmet>
        <title>User</title>
      </Helmet>
      <div></div>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <Row>
                    <div className="d-flex justify-content-between my-2">
                      <h2>USER</h2>
                      <ActionButtons 
                        actions={actions}
                        context="user"
                        handlers={{
                          create: () => navigate("/user"),
                        }}
                      />
                    </div>
                  </Row>
                  <FilterAdmin
                    setObjFilter={setObjFilter}
                    placeholderSearch={"Search by email"}
                    isFistRender={isFistRender}
                  />
                  <Row className="my-2">
                    {loadingUser ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <CustomDatatable
                          columns={columns}
                          rows={listaUser.records}
                          rowCount={listaUser.totalRecords}
                          pagination
                          paginationMode="server"
                          paginationModel={paginationModel}
                          onPaginationModelChange={handlePageChange}
                          onSortModelChange={handleSortChange}
                          onRowClick={handleRowClick}
                          pageSizeOptions={PAGE_SIZE_OPTIONS}
                          checkboxSelection={false}
                          disableColumnFilter
                          disableColumnMenu
                        />
                      </>
                    )}
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  UserReducer: { loadingUser, listaUser, dropdownUser, pageSizeUser, messageUser },
}) => ({
  loadingUser,
  listaUser,
  dropdownUser,
  pageSizeUser,
  messageUser
});

const mapDispatchToProps = {
  getListaUserRequest: getListaUser.request,
  getDropDownUserRequest: getDropDownUser.request,
  loadEmptyUser,
  changePageSizeUser,
  cleanMessageUser,
};

const columns = [
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    sortable: false,
    renderHeader: renderHeader
  },
  {
    field: "active",
    headerName: "Active Status",
    flex: 1,
    type: "boolean",
    sortable: false,
    renderHeader: renderHeader,
    renderCell: renderBoolean,
  },
  {
    field: "createDate",
    headerName: "Creation Date",
    flex: 1,
    renderCell: renderFormatedDate,
    sortable: false,
    renderHeader: renderHeader
  },
  {
    field: "updateDate",
    headerName: "Update Date",
    flex: 1,
    renderCell: renderFormatedDate,
    sortable: false,
    renderHeader: renderHeader
  },
];

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
